import todo from '../assests/todo.png'
import linkedinclone from '../assests/linkedinclone.png'
import eventticketmarketplace from '../assests/eventticketmarketplace.png'
import stockMarketAnalysisFullStack from '../assests/stockMarketAnalysisFullStack.png'
import drumkit from '../assests/drumkit.png'
import dicegame from '../assests/dicegame.png'
import simongame from '../assests/simongame.png'
import audiobookconvertor from '../assests/audiobookconvertor.png'
import weather from '../assests/weather.png'
import tradingJournal from '../assests/tradingJournal.png'
import dataExtraction from '../assests/dataExtraction.png'
import moviecritic from '../assests/moviecritic.png'

export const projectList = [
    {
        name: 'Stock Market Analysis Live Demo',
        image: stockMarketAnalysisFullStack,
        skills: 'React, TypeScript, FastAPI, PostgreSQL, NewsAPI, NSEPy, Recharts, Tailwind CSS',
        link: <a href="https://stock-market-analysis-frontend.vercel.app/">https://stock-market-analysis-frontend.vercel.app/</a>
    },
    {
        name: 'MovieCritic',
        image: moviecritic,
        skills: 'React, React Router, Axios, Tailwind CSS, TypeScript, Vite, ESLint, Node.js, Express, Sequelize, PostgreSQL, CORS, Dotenv, Docker, AWS EC2',
        link : <a href="https://aaryanverma.tech">https://aaryanverma.tech/</a>,

    },
    {
        name: 'Decentralized Multichain ECommerce',
        image: eventticketmarketplace,
        skills: 'Express, React, Node, Solidty, Blockchain, Hardhat',
        link : <a href="https://nft-gravity-seven.vercel.app/">https://nft-gravity-seven.vercel.app/</a>,

    },
    {
        name: 'Trading Journal',
        image: tradingJournal,
        skills: 'Node, EJS, MongoDB, JavaScript, Cyclic',
        link : <a href="https://trading-journal.cyclic.app/">https://trading-journal.cyclic.app/</a>,

    },
    {
        name: 'LinkedIn Clone',
        image: linkedinclone,
        skills: 'ReactJS, Redux HTML, CSS, JavaScript, Firebase, Vercel',
        link:<a href="https://linkedin-clone-aaryan.vercel.app/">https://linkedin-clone-aaryan.vercel.app/</a>,
    },
    {
        name: 'Data Extraction',
        image: dataExtraction,
        skills: 'Python, truecallerpy, apify_client',
        link:<a href="https://github.com/aaryan-verma/data-extraction">https://github.com/aaryan-verma/data-extraction</a>,
    },
    {
        name: 'Todo App Live Demo',
        image: todo,
        skills: 'Node.js, Express, MongoDB, React, JWT',
        link : <a href="https://todo-aaryan.up.railway.app/">https://todo-aaryan.up.railway.app/</a>,
    },
    {
        name: 'Weather',
        image: weather,
        skills: 'HTML, CSS, JavaScript, React, Axios',
        link : <a href="https://aaryan-verma.github.io/weather/">https://aaryan-verma.github.io/weather/</a>,
    },
    {
        name: 'Drum Kit',
        image: drumkit,
        skills: 'HTML, CSS, JavaScript',
        link : <a href="https://aaryan-verma.github.io/drumKit/">https://aaryan-verma.github.io/drumKit/</a>,
    },
    {
        name: 'Dice Game',
        image: dicegame,
        skills: 'HTML, CSS, JavaScript',
        link : <a href="https://aaryan-verma.github.io/Dice-game/">https://aaryan-verma.github.io/Dice-game/</a>,
    },
    {
        name: 'Simon Game',
        image: simongame,
        skills: 'HTML, CSS, JavaScript',
        link : <a href="https://aaryan-verma.github.io/simonGame/">https://aaryan-verma.github.io/simonGame/</a>,
    },
    {
        name: 'Audiobook Convertor',
        image: audiobookconvertor,
        skills: 'Python, PyPDF2, pyttsx3',
        link : <a href="https://github.com/aaryan-verma/audioBookConvertor">https://github.com/aaryan-verma/audioBookConvertor</a>,
    },
    
]